// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"103":"f8775628","355":"915e575d","379":"e53dc302","764":"4a758683","889":"052893bf","963":"d0eb2611"}[chunkId] + ".chunk.css";
};